module.exports = __webpack_public_path__ + "static/media/5 1 Leseforstaelse Intro.ee2cb958.mp3";